
{
  "label": "Corners",
  "options": {
    "rounded": "Rounded",
    "square": "Square"
  }
}
